import {
  formatCampaignDollars,
  GIFT_PASS_FALLBACK_PRICE_CENTS,
  type GiftPassBundlePreviewPrice,
} from '@bonsai/shared';

import './gift-pass-bundle-editor.css';

export function BundleFallbackExample({ price }: { price: GiftPassBundlePreviewPrice }) {
  if (price.bundlePriceCents === null) return null;
  return (
    <span className="gpb-ed-aside">
      At {formatCampaignDollars(GIFT_PASS_FALLBACK_PRICE_CENTS)} a pass:{' '}
      <s>{formatCampaignDollars(price.listPriceCents)}</s>{' '}
      <strong className="gpb-ed-good">{formatCampaignDollars(price.bundlePriceCents)}</strong>
    </span>
  );
}
